/**
 * @file PerFigureInput.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-28
 * @modified 2026-10-28
 * @description Pricing & Costing's typed cost / price box with what it is per
 *              (Cam, 28 Oct 2026 — "Allow cost/ sale price figures to be applied
 *              per tonne or per other unit … (user can change there)"): £, the
 *              figure, and a small switch — per the line's own unit, per T, per
 *              kg — with what that comes to on the line ("= £10.00 /25kg bag").
 *              Presentational: the conversion rules are utils/pricePer, the
 *              caller applies them. The switch is buttons, so a click on it
 *              inside the option's <label> never picks the radio.
 */

import React from 'react';

/** "/25kg bag", "/T", "/kg" — the switch's own short words. */
const shortOf = (o) => (o.value === 'unit' ? `/${String(o.label || '').replace(/^per\s+/, '').replace(/^line's own unit$/, 'own unit')}` : (o.value === 't' ? '/T' : '/kg'));

function PerFigureInput({ text = '', per = 'unit', options = [], onText, onPer, disabled = false, ariaLabel, eq = '', placeholder = '0.00' }) {
  return (
    <span className="pc-manual pc-per-input">£<input type="text" inputMode="decimal" value={text} disabled={disabled}
      placeholder={placeholder} aria-label={ariaLabel}
      onChange={(e) => onText(e.target.value.replace(/[£,\s]/g, ''), e.target)} />
      {options.length > 1 && (
        <span className="pc-per" role="group" aria-label="What the figure is per">
          {options.map(o => (
            <button key={o.value} type="button" className={`pc-per-btn${o.value === per ? ' on' : ''}`}
              aria-pressed={o.value === per} disabled={disabled} title={`Type it ${o.label}`}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (o.value !== per) onPer(o.value, e.currentTarget); }}>
              {shortOf(o)}
            </button>
          ))}
        </span>
      )}
      {eq && <span className="pc-per-eq">{eq}</span>}
    </span>
  );
}

export default PerFigureInput;
